// src/components/AdminRoute.js
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Spinner, Container, Alert } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const AdminRoute = () => {
    const { user, loading } = useAuth();
    const { t } = useTranslation();

    // Показываем спиннер пока проверяем аутентификацию
    if (loading) {
        return (
            <Container className="d-flex justify-content-center align-items-center" style={{ height: '80vh' }}>
                <div className="text-center">
                    <Spinner animation="border" variant="primary" />
                    <p className="mt-3">{t('admin.checkingAccess')}</p>
                </div>
            </Container>
        );
    }

    // Перенаправляем на страницу логина, если пользователь не аутентифицирован
    if (!user) {
        return <Navigate to="/login" />;
    }

    // Если пользователь не администратор, показываем сообщение об ошибке
    if (!user.isAdmin) {
        return (
            <Container className="py-5">
                <Alert variant="danger">
                    <Alert.Heading>{t('admin.accessDenied')}</Alert.Heading>
                    <p>{t('admin.adminRightsRequired')}</p>
                </Alert>
            </Container>
        );
    }

    // Используем Outlet вместо children для совместимости с React Router v6
    return <Outlet />;
};

export default AdminRoute;